import * as React from 'react';

import type { InstructorDetailPanelProps } from './InstructorDetailPanel.types';

import { InstructorDetailPanelShell } from './components/instructor-detail-panel-shell/InstructorDetailPanelShell';

const InstructorDetailPanel = React.memo(
  ({
    onClose,
    instructorId,
    canEdit = false,
  }: Readonly<InstructorDetailPanelProps>): React.ReactElement => {
    return (
      <InstructorDetailPanelShell
        onClose={onClose}
        instructorId={instructorId}
        canEdit={canEdit}
      />
    );
  }
);

InstructorDetailPanel.displayName = 'InstructorDetailPanel';
export { InstructorDetailPanel };
